import React from 'react';
import { Button, Typography } from '@equinor/eds-core-react';
import { confirmAlert } from 'react-confirm-alert';

export function CustomConfirm(title: string, msg: string, yes: any, no: any) {
  confirmAlert({
    customUI: ({ onClose }) => (
      <div className='custom-ui className="alert"'>
        <div className="text-wrapper">
          <Typography variant="h2">{title}</Typography>
          <Typography variant="body_short">{msg}</Typography>
        </div>
        <div className="button-wrapper">
          <Button
            variant="outlined"
            onClick={() => {
              yes();
              onClose();
            }}
          >
            Yes
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              no();
              onClose();
            }}
          >
            No
          </Button>
        </div>
      </div>
    ),
  });
}
